export default {
  name: 'mlmValueEstimation',
  namespace: 'network/value_estimation',
  methods: [
    {
      name: 'valueEstimation',
      params: [],
      successCode: 200,
      method: 'Get',
      url: ({ namespace }) => `/v1/mlm/${namespace}/`,
      urlParams: [],
    },
    {
      // the estimation's parameter catalog — REST home of the retired
      // GraphQL valueEstimateParams query (backend #3681)
      name: 'valueEstimationParams',
      params: [],
      successCode: 200,
      method: 'Get',
      url: ({ namespace }) => `/v1/mlm/${namespace}/params/`,
      urlParams: [],
    },
  ],
}
